var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsappicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 0C6.04415 0 0 6.04415 0 13.5C0 16.051 0.708818 18.4402 1.94071 20.4772L0.736843 24.5703C0.43231 25.6057 1.39433 26.5677 2.42966 26.2632L6.52281 25.0592C8.55978 26.2913 10.949 27 13.5 27C20.9558 27 27 20.9558 27 13.5C27 6.04415 20.9558 0 13.5 0ZM10.4466 16.5546C13.1769 19.285 15.7842 19.6449 16.7048 19.6788C18.105 19.7304 19.4683 18.661 19.9998 17.4207C20.1301 17.1169 20.0976 16.7515 19.8794 16.4719C19.1406 15.5257 18.1404 14.8477 17.1631 14.1728C16.7408 13.8807 16.1602 13.9712 15.8491 14.3849L15.0382 15.6203C14.9481 15.7573 14.7693 15.8045 14.627 15.723C14.0782 15.4093 13.2781 14.8743 12.7024 14.2987C12.1275 13.7237 11.625 12.9597 11.343 12.4463C11.2689 12.3113 11.3099 12.1446 11.4334 12.0528L12.6801 11.127C13.0519 10.8051 13.1173 10.2585 12.8436 9.85808C12.2378 8.97168 11.532 7.84512 10.5104 7.1C10.2314 6.89648 9.87849 6.87363 9.58709 6.99851C8.34529 7.53071 7.27075 8.89365 7.32237 10.2964C7.35626 11.217 7.71622 13.8243 10.4466 16.5546Z",
    fill: "#01AB6C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappicon);
export default __webpack_public_path__ + "static/media/whatsappicon.e80634eb609da67292501600f81f37e4.svg";
export { ForwardRef as ReactComponent };